// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Edit_wrapper__3NcX8"};